import { useSelector } from 'react-redux';

interface OwnerResourceProps {
    item: any
};

const useOwnerResource = (props: OwnerResourceProps) => {
    
    const { user } = useSelector( (store: any) => store.authReducer );

    const isDifferentUser = (): boolean => {
        if(!props.item) return false;
        const loggedUserId = user? user.id : '';
        return loggedUserId !== props.item.user_id;
    }

    return {
        isDifferentUser,
    };
    
}

export default useOwnerResource;
